var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.404,
    height: 15.342,
    viewBox: "0 0 15.404 15.342",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16717",
    "data-name": "Group 16717",
    transform: "translate(-584.149 -18.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16913",
    "data-name": "Path 16913",
    d: "M934.764,21.335a2,2,0,0,1-.618.862q-.591.579-1.169,1.17c-.065.066-.1.076-.173,0q-1.479-1.487-2.967-2.967c-.07-.07-.069-.105,0-.174.411-.4.818-.813,1.224-1.222a1.466,1.466,0,0,1,.737-.409c.027-.006.062.005.076-.033h.06a.392.392,0,0,0,.241,0h.03a1.448,1.448,0,0,1,1.03.538c.376.389.762.769,1.147,1.149a1.059,1.059,0,0,1,.381.721Z",
    transform: "translate(-335.21)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16914",
    "data-name": "Path 16914",
    d: "M642.611,115.856a.4.4,0,0,0-.046-.066q-1.493-1.5-2.99-2.988c-.093-.092-.021-.123.028-.172l5.541-5.542q1.1-1.1,2.189-2.194c.081-.081.122-.088.207,0q1.463,1.473,2.936,2.935c.089.089.071.13-.006.207q-3.864,3.858-7.724,7.72A.293.293,0,0,1,642.611,115.856Z",
    transform: "translate(-53.711 -83.662)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16915",
    "data-name": "Path 16915",
    d: "M584.938,396.094l3.108,3.1-1.269.311q-1.049.255-2.1.507a.552.552,0,0,1-.222.03.362.362,0,0,1-.3-.457Q584.549,397.838,584.938,396.094Z",
    transform: "translate(0 -366.141)",
    fill: "#108757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.f454d85dacd50b333909441cbe8d88e2.svg";
export { ForwardRef as ReactComponent };